import { TinyColor } from '@ctrl/tinycolor';
export const getAlphaColor = (baseColor, alpha) => new TinyColor(baseColor).setAlpha(alpha).toRgbString();
export const getSolidColor = (baseColor, brightness) => {
  const instance = new TinyColor(baseColor);
  return instance.darken(brightness).toHexString();
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/theme/themes/default/colorAlgorithm.js
// module id = 3534
// module chunks = 0